exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-spinner[data-v-3a469b94]{display:inline-block;vertical-align:middle}", ""]);

// exports
